import type { ItemNames } from '@ps-smart-cp/ppfw-client';
import { ItemName, Locale } from '@ps-smart-cp/ppfw-client';

interface Schema {
  // 承認者
  approver: string;
}

const names = {
  approver: ItemName.of([Locale.ja, '承認者'], [Locale.en, 'Approver']),
} satisfies ItemNames<Schema>;

interface Record {
  approver: string;
}

const approverGroupMst = {
  names,
};

interface ApproverGroupMst {
  schema: Schema;
  record: Record;
}

export type { ApproverGroupMst };
export { approverGroupMst };
